import React from 'react';
import Images from '../assets/AllImages';
import { useTranslation } from 'react-i18next';

const ABOUTUS = () => {
  const { t } = useTranslation();

  return (
    <>
      <div className="bg-primary py-24 mb-10" style={{ padding: '20px' }}>
        <div className="container mx-auto px-4 py-12 text-center text-white">
          <div className="max-w-3xl mx-auto py-10">
            <img src={Images.Vactor} alt="" className="about-img" />

            <h1 className="text-white fw-bold mb-4 responsive-heading">
              {t('about.title')}
            </h1>

            {/* MOBILE — full-width text */}
            <div className="d-block d-sm-none mx-n3">
              <p className="text-base leading-relaxed mb-8 text-start w-100">
                {t('about.hero.mobile')}
              </p>
            </div>

            {/* DESKTOP/TABLET */}
            <p className="d-none d-sm-block text-base sm:text-lg md:text-xl leading-relaxed mb-8">
              {t('about.hero.desktop')}
            </p>
          </div>
        </div>
      </div>

      {/* Experience Section */}
      <section className="about-section container-fluid">
        <div className="row justify-content-center" style={{ paddingTop: '50px' }}>
          <div className="col-12 col-md-10">
            <div className="row">
              {/* Left Images */}
              <div className="col-12 col-md-6 mb-5 mb-md-0 position-relative experience-images">
                <div className="exp-img-container d-flex">
                  <img src={Images.SwimingSupportMan1} alt="" className="img-fluid img-margin-right" />
                  <img src={Images.SwimingSupportMan2} alt="" className="img-fluid img-padding-top" />
                </div>

                <div className="experience-circle bg-primary text-white fw-bold">
                  <span>
                    {t('about.experience.yearsCount')}
                    <br />
                    {t('about.experience.yearsLabel')}
                  </span>
                </div>
              </div>

              {/* Right Content */}
              <div className="col-12 col-md-6 d-flex justify-content-center flex-column ps-md-5">
                <h3 className="text-primary fw-bold mb-4" style={{ fontSize: '2.5rem' }}>
                  {t('about.health.title')}
                </h3>
                <p className="mb-4" style={{ fontSize: '1.2rem', lineHeight: '1.7', color: '#666' }}>
                  {t('about.health.paragraph')}
                </p>

                <h4 className="text-primary fw-bold mb-4" style={{ fontSize: '1.6rem' }}>
                  {t('about.health.servicesTitle')}
                </h4>
                <ul>
                  <li>{t('about.health.services.1')}</li>
                  <li>{t('about.health.services.2')}</li>
                  <li>{t('about.health.services.3')}</li>
                  <li>{t('about.health.services.4')}</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="container-fluid py-5">
        <div className="row align-items-center justify-content-center">
          <div className="col-12 col-lg-8 p-5 mx-auto">
            <h3 className="text-primary fw-bold mb-4" style={{ fontSize: '2.5rem' }}>
              {t('about.sport.title')}
            </h3>

            <p className="mb-4" style={{ fontSize: '1.2rem', lineHeight: '1.7', color: '#666' }}>
              {t('about.sport.paragraph')}
            </p>

            <h4 className="text-primary fw-bold mb-4" style={{ fontSize: '1.6rem' }}>
              {t('about.sport.perfectTitle')}
            </h4>
            <ul>
              <li>{t('about.sport.perfectList.1')}</li>
              <li>{t('about.sport.perfectList.2')}</li>
              <li>{t('about.sport.perfectList.3')}</li>
              <li>{t('about.sport.perfectList.4')}</li>
            </ul>

            <br /><br />

            <h3 className="text-primary fw-bold mb-4" style={{ fontSize: '2.5rem' }}>
              {t('about.recreation.title')}
            </h3>

            <h4 className="text-primary fw-bold mb-4" style={{ fontSize: '1.2rem' }}>
              {t('about.recreation.question')}
            </h4>

            <p className="mb-4" style={{ fontSize: '1.2rem', lineHeight: '1.7', color: '#666' }}>
              {t('about.recreation.paragraph')}
            </p>

            <h4 className="text-primary fw-bold mb-4" style={{ fontSize: '1.6rem' }}>
              {t('about.recreation.includesTitle')}
            </h4>
            <ul>
              <li>{t('about.recreation.includes.1')}</li>
              <li>{t('about.recreation.includes.2')}</li>
              <li>{t('about.recreation.includes.3')}</li>
              <li>{t('about.recreation.includes.4')}</li>
              <li>{t('about.recreation.includes.5')}</li>
            </ul>

            <br />
          </div>
        </div>
      </div>
    </>
  );
};

export default ABOUTUS;
